import { required, TextInput, useLoading, useNotify, useRefresh } from "react-admin";
import { Button } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { changeState } from "../Show";
import FormModal from "server/components/Modals/FormModal";

const RejectedState = 5;

const RejectCandidacyManager = ({ candidacyId, hasApprovedRanking }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const loading = useLoading();

  const handleConfirm = async data => {
    await changeState(candidacyId, RejectedState, data.comment);
    notify("Кандидатурата е отказана", { type: "success" });
    refresh();
  };

  return (
    <SecuredComponent permission={permissions.canRejectCandidacies}>
      <FormModal
        titleContent="Отказ на кандидатура"
        onConfirm={handleConfirm}
        disableBackdropClose={true}
        triggerButton={
          <Button
            disabled={hasApprovedRanking || loading}
            variant="contained"
            color="error"
            size="medium"
            startIcon={<ThumbDownIcon />}
          >
            {"Откажи Кандидатура"}
          </Button>
        }
      >
        <TextInput
          label="Коментар"
          source="comment"
          multiline
          fullWidth
          validate={required()}
          resettable
        />
      </FormModal>
    </SecuredComponent>
  );
};

export default RejectCandidacyManager;
